webpackJsonp([70144966829960],{

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MovingSquares = function MovingSquares() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'squares' },
	    _react2.default.createElement('div', { className: 'square square-a' }),
	    _react2.default.createElement('div', { className: 'square square-b' }),
	    _react2.default.createElement('div', { className: 'square square-c' }),
	    _react2.default.createElement('div', { className: 'square square-d' }),
	    _react2.default.createElement('div', { className: 'square square-e' }),
	    _react2.default.createElement('div', { className: 'square square-f' })
	  );
	};
	
	exports.default = MovingSquares;
	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _movingSquares = __webpack_require__(41);
	
	var _movingSquares2 = _interopRequireDefault(_movingSquares);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
		return _react2.default.createElement(
			'div',
			{ className: 'container-fluid' },
			_react2.default.createElement(
				'form',
				{ name: 'contact', method: 'POST', netlify: true, className: 'contact-form' },
				_react2.default.createElement(
					'p',
					null,
					_react2.default.createElement(
						'label',
						null,
						'Your Name: ',
						_react2.default.createElement('input', { type: 'text', name: 'name' })
					)
				),
				_react2.default.createElement(
					'p',
					null,
					_react2.default.createElement(
						'label',
						null,
						'Your Email: ',
						_react2.default.createElement('input', { type: 'email', name: 'email' })
					)
				),
				_react2.default.createElement(
					'p',
					null,
					_react2.default.createElement(
						'label',
						null,
						'Message: ',
						_react2.default.createElement('textarea', { name: 'message' })
					)
				),
				_react2.default.createElement(
					'p',
					null,
					_react2.default.createElement(
						'button',
						{ type: 'submit' },
						'Send'
					)
				)
			)
		);
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-10ba4e12c11e3bf3dd06.js